export class User {
    public id: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public roles: string[];
    public companyName: string;
    public locale: string;
    public loginDate?: number; // timestamp
    public isActive?: boolean;
    public confirmedAt?: Date | undefined;
    public profileAvatar?: string | null;
    public factFindRequest?: {
        id?: number;
        completed?: boolean;
        templateType?: 'custom' | 'preset';
        template?: {
            id?: number;
            name?: string;
        };
    };

    public constructor(payload?: any) {
        this.id = payload && payload.id ? payload.id : 0;
        this.email = payload && payload.email ? payload.email : null;
        this.firstName = payload && payload.firstName ? payload.firstName : null;
        this.lastName = payload && payload.lastName ? payload.lastName : null;
        this.roles = payload && payload.roles ? payload.roles : [];
        this.companyName = payload && payload.companyName ? payload.companyName : null;
        this.locale = payload && payload.locale ? payload.locale : 'en';
        this.factFindRequest = payload && payload.factFindRequest ? payload.factFindRequest : null;
        this.profileAvatar = payload ? payload.profileAvatar : undefined;
    }
}
